import * as React from "react";
import { RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/cn";

/**
 * Stale build after a deploy (MV2-843, ds/Guards). A lazy chunk that 404s
 * after a deploy reloads once, silently (see ChunkErrorElement). If it
 * fails twice this banner appears with a manual reload — never a blank page.
 */
export function StaleBuildBanner({
  onReload,
  className,
}: {
  onReload?: () => void;
  className?: string;
}): React.ReactElement {
  const reload = onReload ?? (() => window.location.reload());
  return (
    <div
      role="status"
      className={cn(
        "flex max-w-[640px] items-center gap-2.5 rounded-[10px] border border-[color:color-mix(in_srgb,var(--info)_30%,transparent)] bg-[color:color-mix(in_srgb,var(--info)_9%,transparent)] px-3.5 py-2.5",
        className,
      )}
    >
      <RefreshCw
        size={16}
        className="flex-none text-[color:var(--info)]"
        aria-hidden
      />
      <span className="flex-1 text-[12.5px] leading-[1.4] text-gray-900">
        A new version of the app is available. Reload to pick it up — nothing
        you typed is lost, drafts are kept.
      </span>
      <Button size="sm" onClick={reload}>
        Reload
      </Button>
    </div>
  );
}
